import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface ImageViewerDialogData {
  imageUrl: string;
}

@Component({
  selector: 'app-image-viewer-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinnerModule],
  template: `
    <div class="image-viewer" (click)="close()" (keydown.escape)="close()">
      @if (loading()) {
        <mat-spinner />
      }
      <img
        [src]="data.imageUrl"
        [style.display]="loading() ? 'none' : 'block'"
        (load)="loading.set(false)"
        alt=""
      />
    </div>
  `,
  styles: [`
    .image-viewer {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 200px;
      min-height: 200px;
      cursor: pointer;
    }

    img {
      max-height: 90vh;
      max-width: 90vw;
      object-fit: contain;
    }
  `],
})
export class ImageViewerDialogComponent {
  readonly data = inject<ImageViewerDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef);
  readonly loading = signal(true);

  close(): void {
    this.dialogRef.close();
  }
}
